<div class="contact-container">
    <div class="header-container">
        <app-header [theme]="'transparent'"></app-header>
        <div>
            <p class="first-p">{{'Get-In-Touch'|translate}}</p>
            <p class="second-p">{{'contact-text'|translate}}</p>
        </div>
    </div>
    <div class="map-conatiner">
        <div class="full" id="map"></div>
    </div>
    <div class="office-name-container">
        <h3> {{'office-palce'|translate}} </h3>
        <hr>
        <div class="row mx-0 content-container" [ngStyle]="{'direction':lang==='ar' ? 'rtl' : 'ltr' }">
            <div class="col-sm-4 col-12 mb-3">
                <p>{{'Address'|translate}}</p>
                <p class="info-text">300-1716 16 Ave NW</p>
                <p class="info-text">Calgary, AB T2M 0L7</p>
            </div>
            <div class="col-sm-4 col-12 mb-3">
                <p>{{'Phone-Number'|translate}}</p>
                <p class="info-text">+1 403-457-3112</p>
            </div>
            <div class="col-sm-4 col-12 mb-3">
                <p>{{'Social-Media'|translate}}</p>
                <p>
                    <a href="{{twitterLink}}" target="_blank"> <i class="fa fa-twitter"></i> </a>
                    <a href="{{facebookLink}}" target="_blank"> <i class="fa fa-facebook-square"></i> </a>
                    <a href="{{instaLink}}" target="_blank"> <i class="fa fa-instagram"></i> </a>
                    <a href="{{linkedInLink}}" target="_blank"> <i class="fa fa-linkedin-square"></i> </a>
                    <a href="{{youTubeLink}}" target="_blank"> <i class="fa fa-youtube"></i> </a>
                </p>
            </div>
        </div>
    </div>
    <div class="feedback-container">
        <div>
            <h3> {{'Feedback'|translate}}</h3>
            <hr>
        </div>
        <div>
            <form>
                <div class="form-container row mx-0">
                    <div class="col-sm-6 col-12">
                        <div>
                            <input type="text" [(ngModel)]="name" required class="iput-field" placeholder="Your Name">
                        </div>

                        <div>
                            <input type="email" [(ngModel)]="email" required class="iput-field"
                                placeholder="Your Email Address">
                        </div>
                    </div>
                    <div class="col-sm-6 col-12">
                        <textarea class="iput-field text-area" [(ngModel)]="message" required
                            placeholder="Your Message"></textarea>
                    </div>
                </div>
                <div class="btn-container">
                    <button [disabled]="isEnabld" (click)="onSubmit();">
                        <span *ngIf="isEnabld" class="spinner-border spinner-border-sm mr-3"></span>{{'SUBMIT'|translate}}
                    </button>
                </div>

            </form>
        </div>
    </div>
    <app-subscribe></app-subscribe>

    <app-footer></app-footer>
</div>